import { unitUtils } from '@bootstrap-styled/utils'
import makeAppTheme from './app.theme'
const appTheme = makeAppTheme({})

const { detectUnit, rmUnit, math } = unitUtils

/**
 * Convert px units to rem units
 *
 * @param {String} $values Eg.: 12px - 12 - 12px 3px - 12px 3
 * @param {String|Number} $baseSize Eg.: 15px
 * @return {String} newValues
 */
export const remCalc = (
    $values: string,
    $baseSize = appTheme['$global-font-size'] || 15
): string => {
    const splitValues = $values.split(' ')

    const newValues = splitValues.reduce((prev, curr) => {
        const detectedUnit = detectUnit(curr)

        return detectedUnit === 'px' || !detectedUnit
            ? `${prev} ${math.divide(`${rmUnit(curr)}rem`, rmUnit($baseSize))}`
            : prev + ' ' + curr
    }, '')

    return newValues
}

/**
 * format spacing values map for bootstrap styled library
 *
 * @param {Object} $spacers
 * @return {Object} formattedSpacers
 */
export const formatSpacing = ($spacers: {}): Record<string, { x: string; y: string }> => {
    const formattedSpacers = {}

    for (const [key, value] of Object.entries($spacers)) {
        formattedSpacers[key] = {
            x: value,
            y: value
        }
    }

    return formattedSpacers
}
